import logger from '@/core/observability/logger';
import { SponsoredProductsLocationType } from '@/productDiscovery/SponsoredProducts/interfaces/SponsoredProducts';
import {
  SPTrackingApi,
  type ImpressionsTrackingSpec,
} from '@/productDiscovery/SponsoredProducts/services/tracking/api';
import getPageAndPosition from '@/productDiscovery/SponsoredProducts/utils/getPageAndPosition/getPageAndPosition';

import type { SponsoredProductDisplayed } from '../../Listings/sponsoredProducts/interfaces/sponsoredProduct';

export const sendImpressionsTracking = async (
  products: SponsoredProductDisplayed[],
  location: SponsoredProductsLocationType,
  pageNumber: number,
) => {
  try {
    if (!products.length) return;

    const impressionList: ImpressionsTrackingSpec[] = products.map(
      ({ product, position }) => ({
        cpc: product.cpc,
        location,
        mabaya_ad_info: product.adTrackingData,
        position: getPageAndPosition(pageNumber, position, location),
        product_id: Number(product.productId),
        seller_id: product.sellerId,
      }),
    );

    await SPTrackingApi.trackImpression(impressionList);
  } catch (error) {
    logger.error(
      new Error(
        `Unable to track impressions with ms.sp-tracking: ${
          error.stack || error
        }`,
      ),
    );
  }
};
